import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from './store';
import { rootBaseName } from './routes';
import { ThemeModeProvider } from './providers/ThemeModeProvider';
import { SnackbarProvider } from './utils/snackbar';
import App from './App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename={rootBaseName}>
        <ThemeModeProvider>
          <SnackbarProvider>
            <App />
          </SnackbarProvider>
        </ThemeModeProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);
